module.exports = __webpack_public_path__ + "e9ecd00c63955c7feb47d2e9423888ab.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/plant.jpg
 ** module id = 486
 ** module chunks = 0
 **/